import {
    Descriptions,
    DescriptionsProps,
    Modal,
    ModalProps,
    Skeleton,
} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import {getTenantDatabase} from '../../../service';
import useRequest from '../../../../../../Utils/Hooks/useRequest';

interface Props extends ModalProps {
    id: string;
}
const Index = ({id, onOk, ...props}: Props) => {
    const [defaultData, {loading: getLoading}] = useRequest(
        () => getTenantDatabase(id),
        {},
        [id],
    );

    const items: DescriptionsProps['items'] = [
        {
            key: '1',
            label: 'ip',
            children: defaultData?.ip,
        },
        {
            key: '2',
            label: '端口',
            children: defaultData?.port,
        },
        {
            key: '3',
            label: '账号',
            children: defaultData?.username,
        },
        {
            key: '4',
            label: '密码',
            children: defaultData?.password,
        },
    ];

    return (
        <Modal {...props} title="数据库连接参数" footer={null}>
            <div className={Style.root}>
                <Skeleton active loading={getLoading}>
                    <Descriptions items={items} />
                </Skeleton>
            </div>
        </Modal>
    );
};

export default Index;
